export default {
  install (Vue) {
    let arr = ['日', '一', '二', '三', '四', '五', '六']
    Vue.filter('day', function (val, text) {
      return '' + text + arr[val]
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/filters/day.js
 **/